import React from 'react'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { AdminClassList } from './AdminClassList'
import { InstructorClassList } from './InstructorClassList'

const ClassList = () => {
	const { user } = useAuth()

	// Determine which component to render based on user role
	const renderClassList = () => {
		if (!user) {
			return (
				<div className="text-center p-5">
					<h4>Loading...</h4>
					<p>Please wait while we load your data.</p>
				</div>
			)
		}

		switch (user?.role) {
			case 'Admin':
				return <AdminClassList />
			case 'Instructor':
				return <InstructorClassList />
			default:
				return (
					<div className="text-center p-5">
						<h4>Access Denied</h4>
						<p>You don't have permission to view class lists.</p>
						<p>Your role: {user?.role || 'Not set'}</p>
					</div>
				)
		}
	}

	return renderClassList()
}

export { ClassList }
